module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('lxm-row', {
    attrs: {
      "name": _vm.name
    },
    on: {
      "click": _vm.clicked
    }
  }, [_c('img', {
    staticClass: "lxm-org-item__right-arrow",
    attrs: {
      "src": require("../../images/main/contact/panel-right-arrow.png")
    }
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-247fd126", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-247fd126!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/common/LxmOrgItem.vue
// module id = 827
// module chunks = 0